"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lobbyist = void 0;
const Turmoil_1 = require("../../turmoil/Turmoil");
const constants_1 = require("../../constants");
class Lobbyist {
    constructor() {
        this.name = 'Lobbyist';
        this.description = 'Have all your 7 delegates in parties (Party Leaders and Chairman also count)';
    }
    getScore(player) {
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        let unplacedDelegatesCount = turmoil.getDelegatesInReserve(player.id);
        if (turmoil.lobby.has(player.id))
            unplacedDelegatesCount += 1;
        return constants_1.PLAYER_DELEGATES_COUNT - unplacedDelegatesCount;
    }
    canClaim(player) {
        return this.getScore(player) === constants_1.PLAYER_DELEGATES_COUNT;
    }
}
exports.Lobbyist = Lobbyist;
//# sourceMappingURL=Lobbyist.js.map